export const backButtons = {
  career: 'Back to Career',
  positions: 'Back to Jobs',
  projects: 'Back to Projects',
  successStories: 'Back to Success Stories',
  home: 'Back to the Home Page',
  blog: 'Back to Blog Listing'
};
